module.exports = __webpack_public_path__ + "img/158.45e6728b.jpg";